import { useCallback, useEffect, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { locateMe } from "@/lib/mapFocus";

const KEY = "bl-show-me";

// Your current city on your own map; the exact position never leaves the phone except as a city lookup
export const useMyCity = (enabled) => {
  const qc = useQueryClient();
  const [on, setOn] = useState(() => localStorage.getItem(KEY) === "1");
  const [me, setMe] = useState(null);
  const refresh = useCallback(async (fresh = false) => {
    const pos = await locateMe(fresh);
    const c = await api.lookupLocation(pos);
    setMe(c);
    // Sharing with friends stays live too
    const s = qc.getQueryData(["settings"]);
    if (s?.location_share && s.location?.city !== c.city) api.setLocation(pos).then(() => qc.invalidateQueries({ queryKey: ["settings"] }), () => null);
    return c;
  }, [qc]);
  useEffect(() => {
    if (!enabled || !on) return undefined;
    refresh().catch(() => null);
    const t = setInterval(() => refresh().catch(() => null), 10 * 60 * 1000);
    return () => clearInterval(t);
  }, [enabled, on, refresh]);
  const toggle = async () => {
    if (on) {
      setOn(false); setMe(null); localStorage.removeItem(KEY);
      return null;
    }
    try {
      const c = await refresh(true);
      setOn(true); localStorage.setItem(KEY, "1");
      return c;
    } catch (e) {
      toast.error(e?.message || "Couldn't find where you are");
      return null;
    }
  };
  return { me, toggle };
};
